import { render } from "./DocumentTypesView.vue?vue&type=template&id=4bd2692d"
import script from "./DocumentTypesView.vue?vue&type=script&lang=js"
export * from "./DocumentTypesView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__